import { AnalysisItem, LegendItem, LocationData } from "helpers/models";
import { TDocumentDefinitions } from "pdfmake/interfaces";
import getFooter from "report/common/footer";
import getHeader from "report/common/header";
import getLegend from "report/common/legend";
import getLogo from "report/common/logo";
import getMap from "report/common/map";
import { info } from "report/common/meta";
import page from "report/common/page";
import countUniquePointIds from "report/common/point";
import getReportDetail from "report/line/detail/report";
import getHazard from "report/line/hazard/hazard";

const LINE_REPORT_LEGEND_SELECTOR =
  '[class^="agenda_agenda"], [class^="DrawShapeAgenda_drawShapeAgenda"], [class^="DrawLineAgenda_drawLineAgenda"]';

interface LineSeriesPoint {
  value?: number;
  intensity?: number;
}

interface LineSeries {
  name?: string;
  data?: Array<LineSeriesPoint | number | null>;
  [key: string]: any;
}

interface Param {
  t: any;
  locationSet: LocationData;
  lineName: string;
  lineLength: string;
  projectType: string;
  analysisItems: AnalysisItem[];
  legendItems: LegendItem[];
  currency: string;
  aggregationUnits: string[];
  unit: string;
  locationsFilterInfo: any[];
  lineSeries?: LineSeries[];
  extremeMap?: Map<string, any>;
  selectedShapeId?: string;
}

const getDoc = async ({
  t,
  locationSet,
  lineName,
  lineLength,
  projectType,
  analysisItems,
  legendItems,
  currency,
  aggregationUnits,
  unit,
  locationsFilterInfo,
  lineSeries,
  extremeMap,
  selectedShapeId
}: Param): Promise<TDocumentDefinitions> => {
  const hazardCount = countUniquePointIds(analysisItems);
  const totalCount = locationSet.itemCount || 0;

  const hasLineSeries = !!lineSeries?.length;

  const docDefinition: TDocumentDefinitions = {
    pageOrientation: "landscape",

    pageMargins: [20, 60, 20, 30],

    header: (currentPage, pageCount) =>
      currentPage === 1 ? getHeader(t("report.CatNet"), 842) : getLogo(),

    footer: (currentPage, pageCount) => getFooter(t, currentPage, pageCount),

    content: [
      {
        columns: [
          {
            stack: getReportDetail(
              t,
              lineName,
              lineLength,
              projectType,
              locationsFilterInfo
            )
          },
          {
            stack: await getMap(t("report.Map View"))
          },
          {
            stack: await getLegend(
              t("report.Map Legends"),
              LINE_REPORT_LEGEND_SELECTOR,
              selectedShapeId
            )
          }
        ],
        columnGap: 20
      },

      analysisItems.length && legendItems.length ? page() : "",
      analysisItems.length && legendItems.length
        ? await getHazard(
            t,
            locationSet,
            analysisItems,
            legendItems,
            hazardCount,
            aggregationUnits,
            unit,
            currency,
            lineLength,
            lineSeries,
            extremeMap
          )
        : ""
    ],

    info: info,

    defaultStyle: {
      font: "普惠体",
      fontSize: 8,
      opacity: 0.6,
      lineHeight: 1,
      characterSpacing: 0
    }
  };

  return docDefinition;
};

export default getDoc;
